import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./RctoMobile.css";

export default function RcToMobile() {

  const user = JSON.parse(localStorage.getItem("user"));

  const [rcno, setRcno] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= FETCH HISTORY ON PAGE LOAD =================
  const loadHistory = async () => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_rc_mobile_list.php?user_id=${user.id}`
      );

      const data = await res.json();
      if (data.list) setHistory(data.list);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadHistory();
  }, []);

  // ================= MAIN SEARCH FUNCTION =================
  const handleSearch = async () => {

    if (!rcno) {
      Swal.fire("Enter RC Number");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/rc_to_mobile.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          rcno
        })
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "wallet_low") {
        Swal.fire("Wallet Low", "Please Recharge", "warning");
      }
      else if (data.status === "failed") {
        Swal.fire("Failed", data.message || "No Data Found", "error");
      }
      else if (data.status === "success") {

        // ================= POPUP =================
        await Swal.fire({
          icon: "success",
          title: "Mobile Number Found 🎉",
          html: `
            <b>RC:</b> ${rcno}<br>
            <b>Mobile:</b> ${data.mobile}
          `,
          confirmButtonText: "OK"
        });

        setRcno("");

        // 🔥 Reload history from DB
        loadHistory();
      }

    } catch (e) {
      console.log(e);
      Swal.fire("Server Error", "", "error");
    }

    setLoading(false);
  };


  return (
    <div className="rcmob-wrapper">

      <h2 className="rcmob-title">RC → Mobile Finder</h2>

      <div className="rcmob-box">

        <input
          type="text"
          placeholder="Enter RC Number"
          value={rcno}
          onChange={e => setRcno(e.target.value.toUpperCase())}
        />

        <button onClick={handleSearch}>
          {loading ? "Please wait..." : "Get Mobile Number (₹50)"}
        </button>

      </div>


      {/* ================= HISTORY SECTION ================= */}
      <div className="rcmob-history">

        <h3>Search History</h3>

        {history.length === 0 ? (
          <p className="empty">No history yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>RC Number</th>
                <th>Mobile</th>
                <th>Date & Time</th>
              </tr>
            </thead>

            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{h.rcno}</td>
                  <td>{h.mobile}</td>
                  <td>{h.created_at}</td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}
